export default __webpack_public_path__ + "static/media/hospital.171fb5ce.JPG";